// @ts-ignore TODO LATER FIX IMPLICIT ANY
import Cookies from 'js-cookie';

const DEFAULT_CULTURE = 'en';

export const getCulture = () => Cookies.get('_culture') || DEFAULT_CULTURE;
